import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-500"></i>
                </div>
                <span
                  className="text-lg font-bold text-foreground-950"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  光棍影院
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                光棍影院电影大全收录最新电影免费高清资源，动作片喜剧片等海量免费影视在线观看，经典大片随时畅享。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-950 mb-4">
                <a href="/category/action" className="hover:text-primary-500 transition-colors">电影分类</a>
              </h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-950 mb-4">快捷链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    动作片
                  </Link>
                </li>
                <li>
                  <Link to="/category/comedy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    喜剧片
                  </Link>
                </li>
                <li>
                  <Link to="/category/scifi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    科幻片
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-950 mb-4">免责声明</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                本站所有视频资源均来自互联网，仅供网友学习交流之用。如侵犯您的权益，请联系我们删除。本站不承担任何由于内容的合法性及健康性所引起的争议和法律责任。
              </p>
            </div>
          </div>

          <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 光棍影院 GuangGunYingYuan - 免费高清电影在线观看
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}